var Announcer = /** @class */ (function () {
    function Announcer(dataHook) {
        var announcerElement = document.createElement('div');
        var OFFSCREEN = "border: 0;clip: rect(0 0 0 0);clip: rect(0, 0, 0, 0); height: 1px;margin: -1px;overflow: hidden;padding: 0; width: 1px;position: absolute;";
        announcerElement.setAttribute('data-hook', dataHook);
        announcerElement.setAttribute('style', OFFSCREEN);
        announcerElement.setAttribute('role', 'log');
        announcerElement.setAttribute('aria-live', 'polite');
        this.announcerElement = document.body.appendChild(announcerElement);
    }
    Announcer.prototype.announce = function (text) {
        this.announcerElement.innerText = text;
    };
    Announcer.prototype.cleanup = function () {
        document.body.removeChild(this.announcerElement);
    };
    return Announcer;
}());
export { Announcer };
//# sourceMappingURL=announcer.js.map